import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../../routes";
import DataTable from "../../common/data-table/data-table";
import { FRONT_DESK_FORM } from "../../dashboard-routes";
import frontDeskFormMap from "./front-desk-form-map";

const FrontDeskFormList = () => {
    const [tableHeader] = useState([
        { name: "Form Name", key: "formName" },
        { name: "Description", key: "formDescription" },
    ]);

    const [tableData, setTableData] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        let data = [];
        Object.keys(frontDeskFormMap).forEach((key) => {
            data.push({
                formName: (
                    <div>
                        <Link
                            to={{
                                pathname: DASHBOARD_ROUTE + FRONT_DESK_FORM,
                                state: { formKey: key },
                            }}
                        >
                            {frontDeskFormMap[key].formTitle}
                        </Link>
                    </div>
                ),
                formDescriptionText: frontDeskFormMap[key].formDescription,
                formDescription: frontDeskFormMap[key].formDescription.map((line,i) => <div key={i}>{line}</div>),
            });
        });

        //console.log(data);
        setTableData(data);
    }, []);

    return (
        <div id="tasks">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius border-0 border-bottom">
                    <div className="m-0 h5">Form List</div>
                </div>
            </div>

            <div className="container-fluid p-3 pb-0">
                <div className="card p-4 border-0">
                    <div className="d-flex align-items-center">
                        <label htmlFor="search">Search for Form : </label>
                        <div className="ms-3">
                            <input
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                type="text"
                                placeholder="Search Form Names"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-3">
                <div className="card p-3 border-0">
                    <div className="position-relative">
                        <DataTable 
                            search={searchText} 
                            header={tableHeader} 
                            rawData={tableData} 
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FrontDeskFormList;
